import type {
  ModelReq,
  // ImageEditInput,
  HunyuanGenerateImageInput,
  HunyuanGenerateImageOutput,
  HunyuanARGenerateImageInput,
  HunyuanARGenerateImageOutput,
  // HunyuanEditImageInput,
  // HunyuanEditImageOutput,
} from '../type'
import { InvalidParamsError } from '../errors'

interface HunyuanImageGenerateFn {
  (input: HunyuanARGenerateImageInput): Promise<HunyuanARGenerateImageOutput>
  (input: HunyuanGenerateImageInput): Promise<HunyuanGenerateImageOutput>
}

type GenerateImageFn<TProvider> = TProvider extends 'hunyuan-image'
  ? HunyuanImageGenerateFn
  : (input: unknown) => Promise<unknown>

export class DefaultImageModel<TProvider extends string> {
  public defaultGenerateImageSubUrl = 'images/ar/generations'

  public generateImageSubUrlConfig: Record<string, Array<[RegExp, string]>> = {
    'hunyuan-image': [
      [/^hunyuan-image(-v[12](\..*)?)?$/, 'images/generations'],
    ],
  }

  /** 生成图片 */
  public generateImage: GenerateImageFn<TProvider>

  constructor(
    private req: ModelReq,
    public baseUrl: string,
    public provider: TProvider,
  ) {
    this.generateImage = this.generateImageImpl.bind(this) as GenerateImageFn<TProvider>
  }

  /** generateImage 的实际实现 */
  private async generateImageImpl(input: HunyuanARGenerateImageInput | HunyuanGenerateImageInput,): Promise<HunyuanARGenerateImageOutput | HunyuanGenerateImageOutput> {
    // 当模型为 HY-Image-v3.0-I2I-ToB-v1.0.1 且 provider 为空或为 hunyuan-image 时校验参数
    if (
      typeof input === 'object' && input && 'model' in input && input.model === 'HY-Image-v3.0-I2I-ToB-v1.0.1' && (this.provider === '' || this.provider === 'hunyuan-image')
    ) {
      const typedInput = input
      const imageUrls = typedInput.image_urls as string[] | undefined
      const images = typedInput.images as string[] | undefined

      if (imageUrls && imageUrls.length > 1) {
        throw new InvalidParamsError(
          '当模型为 HY-Image-v3.0-I2I-ToB-v1.0.1 时，image_urls 最多只能有 1 个元素',
          'image_urls',
        )
      }
      if (images && images.length > 1) {
        throw new InvalidParamsError(
          '当模型为 HY-Image-v3.0-I2I-ToB-v1.0.1 时，images 最多只能有 1 个元素',
          'images',
        )
      }
    }

    let subUrl = this.defaultGenerateImageSubUrl

    if (typeof input === 'object' && input && 'model' in input && typeof input.model === 'string') {
      const newSubUrl = this.getGenerateImageSubUrl(this.provider, input.model)
      if (newSubUrl) subUrl = newSubUrl
    }

    const res = (await this.req({
      url: this.getGenerateUrl(subUrl),
      data: input,
      stream: false,
    })) as HunyuanARGenerateImageOutput | HunyuanGenerateImageOutput

    return res
  }

  private getGenerateUrl(subUrl: string) {
    return `${this.baseUrl}/${this.provider}/${subUrl}`
  }

  /**
   * 根据 provider 与 model 解析生成图片的子路径。
   * 按配置顺序用 RegExp 匹配，命中即返回对应 subUrl。
   */
  private getGenerateImageSubUrl(provider: string, model: string): string | undefined {
    const rules = this.generateImageSubUrlConfig[provider]
    if (!rules) return undefined

    for (const [pattern, subUrl] of rules) {
      if (pattern.test(model)) return subUrl
    }

    return undefined
  }
}
